// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_NullableBool.proto

export enum ENUM_NullableBool {
  NULLABLE_BOOL_UNSPECIFIED = 'NULLABLE_BOOL_UNSPECIFIED',
  NULLABLE_BOOL_FALSE = 'NULLABLE_BOOL_FALSE',
  NULLABLE_BOOL_TRUE = 'NULLABLE_BOOL_TRUE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
